import React from 'react';
import PropTypes from 'prop-types';
import Error404 from './Error404';
import Error500 from './Error500';

const ErrorRouter = ({ error }) => {
  let errorComponent;
  switch (error.status) {
    case 404:
      errorComponent = <Error404 />;
      break;
    case 500:
      errorComponent = <Error500 />;
      break;
    default:
      errorComponent = <Error404 />;
  }
  return errorComponent;
};

ErrorRouter.propTypes = {
  error: PropTypes.string
};

export default ErrorRouter;



// WEBPACK FOOTER //
// ./app/javascript/client/components/ErrorRouter.jsx